import React from "react";
import PropTypes from "prop-types";
import { Button, FlexRow, FlexColumn } from "appStyles";
import { Input, TextArea, SelectOptions } from "components";
import styled, { css } from "react-emotion";
import AlertModal from "../../../Tools/AlertModal";
import { priceToDollars, formatDollarsToCents } from "helpers";
import NumberFormat from "react-number-format";
import { toast } from "react-toastify";
import StyledToast from "../../../Tools/StyledToast";
import Alert from "@material-ui/lab/Alert";
import Switch from "@material-ui/core/Switch";

const inputStyle = css`
  width: 100%;
  border: none;
  border: 1px solid #979797;
  background: none;
  outline: none;
  margin: 0 0 10;
  box-shadow: none;
  /* margin-top: 20px; */
  padding: 6px 10px;
  color: #1f3747;
  font-size: 15px;
  box-sizing: border-box;
  border-radius: 3px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;

  &:hover,
  :focus {
    border-color: #aed9da;
    opacity: 1;
    transition: opacity 0.4s;
  }

  &::placeholder {
    color: grey;
    font-size: 1rem;
    opacity: 0.8;
    margin: 5px;
  }
`;
const titleStyle = css`
  white-space: nowrap;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  line-height: 18px;
`;
const formStyle = css`
  position: relative;
  padding: 20px;
  background: white;
  border-radius: 0px 0px 5px 5px;
`;
const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: "white";
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;
const container = css`
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  padding: 20px;
  position: relative;
  padding: 1em;
  border-radius: 5px;
  margin-bottom: 3em;
  margin-top: 1em;
`;

const H2 = styled("h2")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  line-height: 18px;
  color: #1f3747;
  margin: auto;
  margin-bottom: 20px;
`;

const boldButton = css`
  display: inline-block;
  width: 100px;
  text-align: center;

  border-radius: 5.5px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
`;

class Punchcard extends React.Component {
  state = {
    deleteConfirm: false,
    showMaxDiscount: this.props.card.maxDiscount ? true : false,
    error: "",
  };

  notify = (action) => {
    switch (action) {
      case "create":
        toast(
          StyledToast({
            message:
              "🤗 The punchcard " + this.props.card.title + " was created!",
            confirm: true,
          }),
          {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          }
        );
        break;
      case "update":
        toast(
          StyledToast({
            message:
              "👏 The punchcard " + this.props.card.title + " was updated!",
            confirm: true,
          }),
          {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          }
        );
        break;
      case "delete":
        toast(
          StyledToast({
            message:
              "❌ The punchcard " + this.props.card.title + " was deleted!",
          }),
          {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          }
        );
        break;
      default:
        toast.error(action, {
          position: "bottom-right",
          autoClose: false,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
    }
  };

  createPunchCard = () => {
    // console.dir(this.props.card);
    if (this.props.card.title && this.props.card.numberOfUses) {
      this.props
        .createPunchCard({
          appId: this.props.appId,
          ...this.props.card,
        })
        .then((card) => {
          this.props.updateActiveEditor(null);
          this.notify("create");
        });
    } else {
      this.setState({
        error: "Title and number of stamps cannot be empty",
      });
      window.setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  };

  deletePunchCardHelper = () => {
    const { card, removePunchCard, deletePunchCard } = this.props;
    // console.log("card id to be deleted: " + card.id);
    if (this.isNewCard()) {
      // console.log("deleting new card");
      removePunchCard(card);
    } else {
      // console.log("deleting old card");
      deletePunchCard(card);
    }
    this.notify("delete");
    this.toggleModal();
    this.props.updateActiveEditor(null);
  };

  toggleModal = () => {
    const { deleteConfirm } = this.state;
    // console.log("toggling...delete confirm is: " + this.state.deleteConfirm);
    this.setState({
      deleteConfirm: !deleteConfirm,
    });
    // console.log(
    //   "toggle complete...delete confirm is: " + this.state.deleteConfirm
    // );
  };
  toggleMaxDiscount = () => {
    const { showMaxDiscount } = this.state;
    // console.log(
    //   "toggling...show max discount is: " + this.state.showMaxDiscount
    // );

    this.setState({
      showMaxDiscount: !showMaxDiscount,
    });

    // console.log(
    //   "toggle complete...max discount is: " + this.state.showMaxDiscount
    // );
  };

  getButtons = () => {
    return [
      <a
        key="cancelButton"
        variant="contained"
        style={{
          backgroundColor: "white",
          cursor: "pointer",
          color: "#1976d2",
          fontWeight: "500",
          lineHeight: "1.75",
          borderRadius: "4px",
          letterSpacing: "0.02857em",
          textTransform: "uppercase",
          fontSize: "0.9375rem",
        }}
        onClick={this.toggleModal}
      >
        Cancel
      </a>,
      <a
        onClick={this.deletePunchCardHelper}
        style={{
          cursor: "pointer",
          backgroundColor: "white",
          color: "red",
          fontWeight: "500",
          lineHeight: "1.75",
          borderRadius: "4px",
          letterSpacing: "0.02857em",
          textTransform: "uppercase",
          paddingLeft: "10px",
          fontSize: "0.9375rem",
        }}
      >
        Delete
      </a>,
    ];
  };
  renderDeletionConfirmationModal = () => {
    const { deleteConfirm } = this.state;
    // console.log("rendering modal! with delete confirm:" + deleteConfirm);
    if (!deleteConfirm) return null;
    return (
      <AlertModal
        title="Are you sure? This will delete all your customers' punch cards."
        render={deleteConfirm}
        buttons={this.getButtons()}
      >
        <P>
          After deleting this punchcard, all the stamps accumulated by your
          customers will no longer be available. Please be sure your customers
          are aware of this. One option is to give the customers a few weeks to
          redeem their punch card before deleting.
        </P>
      </AlertModal>
    );
  };

  update = (field) => (value) => {
    if (field === "maxDiscount") {
      value = formatDollarsToCents(value["value"]);
    }
    this.props.updatePunchCard({
      ...this.props.card,
      [field]: value,
    });
  };

  handleChange = (event) => {
    // console.log(event);
    this.props.updatePunchCard({
      ...this.props.card,
      [event.target.name]: event.target.checked,
    });
  };

  numberOptions = () => {
    return [...Array(30)].map((i, idx) => ({
      value: idx + 1,
      label: idx + 1,
    }));
  };

  isNewCard = () => {
    return this.props.card.id === "newCard";
  };

  // if (!activeEditor) return null;
  render() {
    const {
      id,
      title,
      numberOfUses,
      retired,
      finePrint,
      description,
      maxDiscount,
      isPublic,
    } = this.props.card;

    // console.dir(this.props.card);

    return (
      <div className={container}>
        <form className={formStyle}>
          {!this.isNewCard() && (
            <H2 style={{ marginBottom: "20px" }}>Punchcard Details</H2>
          )}
          {this.isNewCard() && (
            <H2 style={{ marginBottom: "20px" }}>New Punchcard</H2>
          )}
          <FlexRow style={{ height: "auto" }}>
            <FlexColumn
              width="50%"
              style={{ margin: "0px", marginRight: "20px" }}
            >
              <Input
                field="Title (i.e. Buy 5 Coffees Get 1 Free)"
                validateInput="true"
                defaultValue={title}
                onChange={this.update("title")}
                disabled={!this.isNewCard()}
              />
              <TextArea
                width="100%"
                height="5rem"
                // fontSize="1em"
                placeholder="Description (i.e. When you buy any 5 coffees through our mobile app, you’ll get one free on the next order.)"
                text={description}
                onChange={this.update("description")}
                disabled={!this.isNewCard()}
              />
              <FlexRow margin="20px 0 0 0" style={{ justifyContent: "start" }}>
                <span className={titleStyle} style={{ marginRight: "10px" }}>
                  {" "}
                  # of stamps:
                </span>
                <SelectOptions
                  width="100px"
                  value={numberOfUses}
                  options={this.numberOptions()}
                  setValue={this.update("numberOfUses")}
                  isDisabled={!this.isNewCard()}
                />
              </FlexRow>
              <TextArea
                width="100%"
                height="5rem"
                // fontSize="1em"
                placeholder="Fine Print"
                text={finePrint}
                onChange={this.update("finePrint")}
                disabled={!this.isNewCard()}
              />

              <div
                className={titleStyle}
                style={{
                  padding: "20px 0px 0px",
                  display: "flex",
                  alignSelf: "flex-start",
                  alignItems: "center",
                }}
              >
                <span className={titleStyle} style={{ marginRight: "5px" }}>
                  Set Max Discount
                </span>
                <Switch
                  onChange={this.toggleMaxDiscount}
                  checked={this.state.showMaxDiscount}
                  disabled={!this.isNewCard()}
                  color="primary"
                />
              </div>

              {this.state.showMaxDiscount && (
                <NumberFormat
                  placeholder="$10"
                  thousandSeparator={true}
                  prefix={"$"}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  allowNegative={false}
                  allowLeadingZeros={false}
                  defaultValue={
                    maxDiscount ? priceToDollars(maxDiscount) : null
                  }
                  onValueChange={this.update("maxDiscount")}
                  className={inputStyle}
                  // disabled={id != "newCoupon"}
                  style={{
                    backgroundColor: !this.isNewCard() ? "lightgrey" : "white",
                    color: !this.isNewCard() ? "gray" : "rgb(31, 55, 71)",
                  }}
                  disabled={!this.isNewCard()}
                />
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  alignSelf: "flex-start",
                }}
              >
                <p
                  style={{
                    fontSize: "15px",
                    margin: "20px 0px",
                    marginRight: "15px",
                  }}
                >
                  Publicly Display on Mobile360 Marketplace
                </p>
                <Switch
                  checked={isPublic}
                  onChange={this.handleChange}
                  color="primary"
                  name="isPublic"
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
              </div>
            </FlexColumn>
          </FlexRow>
          <FlexRow style={{ justifyContent: "flex-end", height: "auto" }}>
            {this.state.error && (
              <Alert severity="error">{this.state.error}</Alert>
            )}

            {!retired && !this.isNewCard() && (
              <Button
                background="#F17F7F"
                // onClick={this.toggleModal}
                onClick={this.toggleModal}
                className={boldButton}
              >
                Delete
              </Button>
            )}
            {this.isNewCard() && (
              <Button
                className={boldButton}
                background="#89D2D3"
                onClick={this.createPunchCard}
              >
                Create
              </Button>
            )}
          </FlexRow>
          {this.renderDeletionConfirmationModal()}
        </form>
      </div>
    );
  }
}

// Punchcard.propTypes = {
//   card: PropTypes.object,
//   deletePunchCard: PropTypes.func,
// };

export default Punchcard;
